export default {
  data() {
    return {
      showAllSearchBar: false,
      searchBarDom: null,
      height: 0,
    };
  },
  mounted() {
    let searchBarDom = document.querySelector('.left-box');
    let filterItemDom = document.querySelector('.filter-item');
    this.searchBarDom = searchBarDom;
    let height =
      (filterItemDom.clientHeight +
        parseInt(window.getComputedStyle(filterItemDom)['margin-bottom'])) *
      2;
    this.height = height;
    this.searchBarDom.style = `height: ${height}px;overflow: hidden;max-height: ${height}px`;
  },
  methods: {
    showSearchBarHandle() {
      if (this.showAllSearchBar) {
        this.showAllSearchBar = !this.showAllSearchBar;
        this.searchBarDom.style = `height: ${
          this.height
        }px;overflow: hidden;max-height: ${this.height}px`;
      } else {
        this.showAllSearchBar = !this.showAllSearchBar;
        this.searchBarDom.style =
          'height: auto;overflow: hidden;max-height: 500px';
      }
    },
  },
};
